var v1ToV6 = {};

export { v1ToV6 as __exports };
//# sourceMappingURL=v1ToV6.js.map
